import errorMessages from "utils/validation/errorMessages";
import { emailSchema, phoneRequiredSchema, select2OptionalSchema, select2RequiredSchema, statusSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, number, object, string } from 'yup';

const schoolClientFormSchema = object().shape({
	firstname: stringRequiredSchema,
	lastname: stringRequiredSchema,
	dob: stringRequiredSchema,
	gender: select2RequiredSchema,
	grade: select2RequiredSchema,
	city_town: stringRequiredSchema,
	school_division: select2RequiredSchema,
	school_profile: select2RequiredSchema,
	date_of_expiry: stringRequiredSchema,
	// service_status: select2RequiredSchema,
	teachers: array().of(object().shape({
		firstname: stringRequiredSchema,
		lastname: select2RequiredSchema,
		phone: phoneRequiredSchema,
		email: emailSchema,
		id: number().nullable().optional()
	})),
	// parents: array().of(object().shape({
	// 	firstname: stringRequiredSchema,
	// 	lastname: select2RequiredSchema,
	// 	phone: phoneRequiredSchema,
	// 	email: emailSchema,
	// })),
	documents: array().of(object().shape({
		attachment_key: stringRequiredSchema,
		attachment_name: stringRequiredSchema
	})),
	notes: string().notRequired(),
	status: statusSchema,
});

export default schoolClientFormSchema;